// React
import React from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';

// Third party
import { useParams } from 'react-router-dom';

// Taxonomies
import {
  salesVersionCore,
  salesVersionDetail
} from '../../../taxonomies/salesVersion';

// This component
export default function SalesVersionDetail() {
  const { itemHash } = useParams();
  const isNewItem = itemHash === 'new';

  // Taxonomies
  const { endpoint, getDetailId, getDetailHash } = salesVersionCore();
  const { baseUrl, getInputs } = salesVersionDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'taxonomy',
        title: 'Sales Version',
        // Static
        itemHash,
        isNewItem,
        endpoint,
        baseUrl,
        getDetailId,
        getDetailHash,
        getInputs,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
